import React from 'react';

const About = () => {
    return (
        <section id="about" className="about">
            <div className="container">
                <div className="about-content">
                    <div className="about-text">
                        <h2>About F.A Real Estate</h2>
                        <p>F.A Real Estate is a leading property consultancy firm dedicated to helping you find the perfect property. With years of experience in the real estate market, we provide exceptional service and expertise.</p>
                        <p>Our team of professional agents is committed to understanding your needs and delivering solutions that exceed your expectations. Whether you're looking to buy, sell, or invest, we're here to guide you every step of the way.</p>
                        <div className="stats">
                            <div className="stat-item">
                                <h3>500+</h3>
                                <p>Properties Sold</p>
                            </div>
                            <div className="stat-item">
                                <h3>1000+</h3>
                                <p>Happy Clients</p>
                            </div>
                            <div className="stat-item">
                                <h3>15+</h3>
                                <p>Years Experience</p>
                            </div>
                        </div>
                    </div>
                    <div className="about-image">
                        <div className="about-image-container">
                            <img 
                                src="https://images.unsplash.com/photo-1560518883-ce09059eeffa?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1973&q=80" 
                                alt="F.A Real Estate Office"
                                className="about-image-photo"
                                onError={(e) => {
                                    e.target.style.display = 'none';
                                    e.target.nextElementSibling.style.display = 'flex';
                                }}
                            />
                            <div className="image-placeholder" style={{ display: 'none' }}>
                                <i className="fas fa-building"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;
